import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Dashboard } from "../../Pages/Dashboard/Dashboard";
import { Sandbox } from "../../Pages/Sandbox/Sandbox";
import { Redux } from "../../Pages/Redux/Redux";
import { ExpenseManagerRouterMfe } from "../../Pages/ExpenseManager/ExpenseManagerRouterMfe";
import { SettingsPage } from "../../Pages/Settings/SettingsPage";
import { checkDeveloperMode } from "../../DeveloperWorkbench/DeveloperWorkbench.utils";
import type { AppRoutesProps } from "./AppRoutes.types";
export const AppRoutes: React.FC<AppRoutesProps> = ({
  routesLoading,
  routes,
  isCounterInjected,
  setIsCounterInjected,
  reduxStateStr,
  userName,
  userEmail,
  userData,
}) => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />

      <Route
        path="/dashboard"
        element={<Dashboard routesLoading={routesLoading} routes={routes} />}
      />

      <Route
        path="/sandbox/*"
        element={
          checkDeveloperMode() ? (
            <Sandbox routesLoading={routesLoading} routes={routes} />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      />

      <Route
        path="/redux"
        element={
          checkDeveloperMode() ? (
            <Redux
              isCounterInjected={isCounterInjected}
              setIsCounterInjected={setIsCounterInjected}
              reduxStateStr={reduxStateStr}
            />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      />



      <Route
        path="/expense"
        element={<Navigate to="/expense/manager" replace />}
      />

      <Route
        path="/expense/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />
      
      <Route
        path="/expense/automated-tracker/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/expense/budgets/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/expense/credit-cards/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/expense/bank-accounts/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/expense/banks/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/expense/loans/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/expense/vaults/*"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/auth/google/callback"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/google-oauth-callback"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />

      <Route
        path="/google-auth/api-concent-response"
        element={
          <ExpenseManagerRouterMfe routesLoading={routesLoading} routes={routes} />
        }
      />



      <Route
        path="/settings"
        element={
          <SettingsPage
            currentName={userName}
            currentEmail={userEmail}
            user={userData?.me}
          />
        }
      />


    </Routes>
  );
};

export default AppRoutes;
